import api from "./Api";

class RelatorioNovaService {
    async buscarContasSalario(esteiraID: number, erro: boolean): Promise<any> {
        const { data: result } = await api.get<any[]>(`v2/Relatorio/ContasSalario/${esteiraID}/${erro}`);
        return result;
    }
}


export default new RelatorioNovaService();